import { Navigate } from 'react-router';

import {
  ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE,
  ANY_SPORT_PLAY_BOARDS_PRO,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { Mode } from '#src/components/pickers/ModePicker/index.tsx';
import { useLastVisitedBoardView } from '#src/hooks/useLastVisitedBoardView.ts';
import { modeToArenaMode } from '#src/lib/arenaMode.ts';

const BoardsPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedView } = useLastVisitedBoardView();

  const lastMode = lastVisitedView?.lastVisitedMode;

  if (([Mode.ARENA_CASH, Mode.ARENA_ESSENCE] as Mode[]).includes(lastMode!)) {
    const arenaMode = modeToArenaMode(lastMode!);
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE, {
          params: { arenaMode },
        })}
        replace
      />
    );
  }

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_PRO)}
      replace
    />
  );
};

export default BoardsPage;
